@if (cfg.appName === "ia") {
  <div class="createPlantFooter"><ng-content></ng-content></div>
}
@if (cfg.appName === "em") {
  <app-tab-menu></app-tab-menu>
}
